import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { AccountSwitcher, DomainConfig, SenderAccount } from './AccountSwitcher';
import { ComposeModal } from '../inbox/ComposeModal';

interface LayoutProps {
    accounts: DomainConfig[];
    selectedAccount: SenderAccount | null;
    onSelectAccount: (s: SenderAccount) => void;
    unreadCount: number;
    composeOpen: boolean;
    onComposeOpen: () => void;
    onComposeClose: () => void;
    authLabel?: string;
    onLogout?: () => void;
}

export function Layout({
    accounts,
    selectedAccount,
    onSelectAccount,
    unreadCount,
    composeOpen,
    onComposeOpen,
    onComposeClose,
    authLabel,
    onLogout,
}: LayoutProps) {
    return (
        <div className="app-layout">
            <Sidebar unreadCount={unreadCount} />

            <div className="app-main">
                <header className="app-header">
                    <button className="btn btn-primary" onClick={onComposeOpen}>
                        ✉️ Compose
                    </button>

                    <AccountSwitcher
                        accounts={accounts}
                        selected={selectedAccount}
                        onSelect={onSelectAccount}
                    />

                    {/* Auth info + Logout */}
                    {authLabel && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto' }}>
                            <span style={{
                                padding: '4px 10px',
                                background: 'rgba(99, 102, 241, 0.15)',
                                border: '1px solid rgba(99, 102, 241, 0.3)',
                                borderRadius: 6,
                                fontSize: 11,
                                fontWeight: 600,
                                color: '#a5b4fc',
                            }}>
                                🔐 {authLabel}
                            </span>
                            {onLogout && (
                                <button
                                    onClick={onLogout}
                                    style={{
                                        padding: '4px 10px',
                                        background: 'rgba(239, 68, 68, 0.1)',
                                        border: '1px solid rgba(239, 68, 68, 0.3)',
                                        borderRadius: 6,
                                        fontSize: 11,
                                        fontWeight: 600,
                                        color: '#f87171',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Logout
                                </button>
                            )}
                        </div>
                    )}
                </header>

                <main className="app-content">
                    <Outlet />
                </main>
            </div>

            {composeOpen && (
                <ComposeModal
                    accounts={accounts}
                    defaultSender={selectedAccount}
                    onClose={onComposeClose}
                />
            )}
        </div>
    );
}

